export const CURRENCY_BLOCKER_DEFAULT_CURRENCY = 'defaultCurrency';
export const CURRENCY_BLOCKER_USED_IN_ZONE = 'currencyInZone';
export const CURRENCY_BLOCKER_USED_IN_MEMBER = 'currencyInMember';
export const CURRENCY_BLOCKER_USED_IN_MANUAL_CASH_LIMIT = 'currencyInManualCashLimit';

export const transformCurrencyDeactivationBlockers = (t, blockerKey) => {
    let result;
    switch (blockerKey) {
        case CURRENCY_BLOCKER_DEFAULT_CURRENCY:
            result = t('currencies.blocker.default-currency-deactivation');
            break;
        case CURRENCY_BLOCKER_USED_IN_ZONE:
            result = t('currencies.blocker.currency-used-in-zone');
            break;
        case CURRENCY_BLOCKER_USED_IN_MEMBER:
            result = t('currencies.blocker.currency-used-in-member');
            break;
        case CURRENCY_BLOCKER_USED_IN_MANUAL_CASH_LIMIT:
            result = t('currencies.blocker.currency-used-in-manual-cash-limit');
            break;
        default:
            throw new Error(`Unknown blocker key: ${blockerKey}`);
    }
    return result;
};

export const transformCurrencyModificationBlockers = (t, blockerKey) => {
    let result;
    if (blockerKey === CURRENCY_BLOCKER_DEFAULT_CURRENCY) {
        result = t('currencies.blocker.default-currency-modification');
    } else {
        throw new Error(`Unknown blocker key: ${blockerKey}`);
    }
    return result;
};
